import { useContext } from 'react'
import { SnackbarContext } from '../contexts/Snack'
import { SnackbarActionTypes, SnackbarStateType } from '../contexts/Snack/types'

function useSnackbar() {
  const ctx: any = useContext(SnackbarContext)

  const { dispatch } = ctx

  const trigger = (payload: SnackbarStateType) =>
    dispatch({
      type: SnackbarActionTypes.OPEN_SNACKBAR,
      payload: { ...payload, open: true },
    })

  return { trigger }
}

export default useSnackbar
